import React, { useState, Fragment, useEffect } from 'react'
import { formBtn1, formBtn2, inputClass, labelClass } from '../Components/Utils/CustomClasses'
import { Dialog, Transition } from '@headlessui/react'
import { useForm } from 'react-hook-form';
import Error from '../Components/Error/Error'
import { validateEmail, validatePassword, validatePhoneNumber } from '../Components/Utils/Validation';
import { Tooltip } from 'antd';
import { GetAllCompanyAPI, GetAllRolesAPI, RegisterUserAPI, UpdateAdminUserAPI } from '../API/Api';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import ButtonLoader from '../Components/Loader/ButtonLoader';
import { IconEdit, IconEye, IconEyeOff, IconInfoCircle } from '@tabler/icons-react';

export default function AddAdmin({ edit, rowdata, filterRecords, Company }) {
    const { register, handleSubmit, control, watch, reset, formState: { errors }, setValue } = useForm();
    const userDetails = useSelector(state => state?.login?.userDetails)
    const [isOpen, setIsOpen] = useState(false)
    const [eyeIcon, setEyeIcon] = useState(false);
    const [RolesList, setRolesList] = useState([])
    const [loader, setLoader] = useState(false)
    const toggle = () => {
        setIsOpen(!isOpen)
        reset()
    }

    const handleCompanySelect = async (id) => {
        try {
            let response = await GetAllRolesAPI(id)
            setRolesList(response?.data?.filteredData)
        } catch (err) {
            console.log('Error', err)
        }
    }

    const onSubmit = async (data) => {
        setLoader(true)
        const payload = {
            'first_name': data?.first_name,
            'last_name': data?.last_name,
            'email': data?.email,
            'password': data?.password,
            'phone_number': data?.phone_number,
            'company': data?.company,
            'role': data?.role,
            'assign_to': userDetails?._id
        }
        try {
            let response
            if (edit == true) {
                response = await UpdateAdminUserAPI(rowdata?._id, data)
            } else {
                response = await RegisterUserAPI(payload)
            }
            if (response?.status == 201) {
                setLoader(false)
                toast.success(response?.data?.message)
                setRolesList([])
                filterRecords();
                toggle();
            } else{
                setLoader(false)
                toast.error(response?.error)
            }
        } catch (err) {
            setLoader(false)
            console.log('Error:', err)
        }
    }

    useEffect(() => {
        if (userDetails?.first_name) {
            setValue('assign_to', `${userDetails?.first_name} ${userDetails?.last_name}`)
        }
    }, [isOpen])

    useEffect(() => {
        if (edit == true) {
            reset({
                'first_name': rowdata?.first_name,
                'last_name': rowdata?.last_name,
                'email': rowdata?.email,
                'phone_number': rowdata?.phone_number
            })
        }
    }, [isOpen, edit])

    return (
        <>
            {
                edit ? <button onClick={toggle} className='py-1 rounded-lg flex justify-center w-1/2'>
                    <IconEdit stroke={1.5} size={24} color="#000" />
                </button> : <button onClick={toggle} className={formBtn1}>Add Admin</button>
            }

            <Transition appear show={isOpen} as={Fragment} >
                <Dialog as='div' className='relative z-[100]' onClose={toggle}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>
                    <div className="fixed inset-0 overflow-y-scroll ">
                        <div className='flex items-center justify-center min-h-full p-4 text-center'>
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel
                                    className="w-full max-w-2xl overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl"
                                >
                                    <Dialog.Title
                                        as="h2"
                                        className="w-full px-3 py-4 text-lg font-semibold leading-6 text-white bg-base-color font-tb"
                                    >{edit ? 'Edit Admin' : 'Add Admin'}</Dialog.Title>
                                    <div>
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div className="p-2">
                                                <div className="grid py-4 mx-4 md:grid-cols-1 lg:grid-cols-2 gap-x-3 gap-y-3 customBox">
                                                    <div className="">
                                                        <label className={labelClass}>
                                                            First Name<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            type='text'
                                                            className={inputClass}
                                                            {...register('first_name', { required: true })}
                                                        />
                                                        {errors.first_name && <Error title='First Name is Required*' />}
                                                    </div>
                                                    <div className="">
                                                        <label className={labelClass}>
                                                            Last Name<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            type='text'
                                                            className={inputClass}
                                                            {...register('last_name', { required: true })}
                                                        />
                                                        {errors.last_name && <Error title='Last Name is Required*' />}
                                                    </div>
                                                    <div className="">
                                                        <label className={labelClass}>
                                                            Email<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            type='text'
                                                            className={inputClass}
                                                            {...register('email', { validate: validateEmail })}
                                                        />
                                                        {errors.email && <Error title={errors.email.message} />}
                                                    </div>
                                                    {edit == false && (
                                                        <div className="">
                                                            <label className={`${labelClass} flex`}>
                                                                Password<span style={{ color: "red" }}>*</span>
                                                                <span className='ml-1'>
                                                                    <Tooltip
                                                                        title={
                                                                            <>
                                                                                <div>Password must contain at least first letter uppercase one special character and one number</div>
                                                                            </>
                                                                        }
                                                                        placement="right"
                                                                        color="#032037"
                                                                    >
                                                                        <IconInfoCircle stroke={1.5} size={23} color='#000'/>
                                                                    </Tooltip>
                                                                </span>
                                                            </label>
                                                            <div className='mt-1 relative flex items-center'>
                                                                <input
                                                                    type={!eyeIcon ? "password" : "test"}
                                                                    className={inputClass}
                                                                    {...register('password', { validate: validatePassword })}
                                                                />
                                                                <span className="absolute right-2 z-10 " onClick={() => setEyeIcon(!eyeIcon)}>
                                                                    {
                                                                        eyeIcon ? 
                                                                            <IconEye stroke={1.5} size={24} color='#000' className='cursor-pointer' />
                                                                            : <IconEyeOff stroke={1.5} size={24} color='#000' className='cursor-pointer'/>
                                                                    }
                                                                </span>
                                                            </div>
                                                            {errors.password && <Error title={errors.password.message} />}
                                                        </div>
                                                    )}

                                                    <div className="">
                                                        <label className={labelClass}>
                                                            Phone Number<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            type='text'
                                                            className={inputClass}
                                                            {...register('phone_number', { validate: validatePhoneNumber })}
                                                        />
                                                        {errors.phone_number && <Error title={errors.phone_number.message} />}
                                                    </div>
                                                    {edit == false && (
                                                        <div className="">
                                                            <label className={labelClass}>
                                                                Company Name<span style={{ color: "red" }}>*</span>
                                                            </label>
                                                            <select
                                                                className={inputClass}
                                                                {...register("company", { required: true })}
                                                                onChange={(e) => handleCompanySelect(e.target.value)}
                                                            >
                                                                <option value="">Select Company Name</option>
                                                                {
                                                                    Company?.map(company => (
                                                                        <option value={company?._id} key={company?._id}>{company?.companyName}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                            {errors.company && <Error title='Company Name is Required*' />}
                                                        </div>
                                                    )}

                                                    {edit == false && (
                                                        <div className="">
                                                            <label className={labelClass}>
                                                                Role<span style={{ color: "red" }}>*</span>
                                                            </label>
                                                            <select className={inputClass} {...register("role", { required: true })}>
                                                                <option value="">Select Role</option>
                                                                {RolesList && RolesList.length > 0 ? (
                                                                    RolesList.filter(role => role?.roleName === "Admin").map(role => (
                                                                        <option value={role?._id} key={role?._id}>{role?.roleName}</option>
                                                                    ))
                                                                ) : (
                                                                    <option value="">No Roles Found</option>
                                                                )}
                                                            </select>
                                                            {errors.role && <Error title='Role is Required*' />}
                                                        </div>
                                                    )}
                                                    {
                                                        edit == false && (
                                                            <div className="">
                                                                <label className={labelClass}>
                                                                    Assign To<span style={{ color: "red" }}>*</span>
                                                                </label>
                                                                <input
                                                                    type='text'
                                                                    disabled
                                                                    className={inputClass}
                                                                    {...register('assign_to', { required: true })}
                                                                />
                                                                {errors.assign_to && <Error title={errors.assign_to.message} />}
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            <footer className="flex justify-end px-4 py-2 space-x-3 bg-white">
                                                {
                                                    edit == true ? (
                                                        loader ? <ButtonLoader /> : <button
                                                            type="submit"
                                                            className={`${formBtn1} relative px-4 py-2 text-white font-bold rounded-lg flex items-center justify-center`}
                                                        >
                                                            <span className="opacity-100">
                                                                Update
                                                            </span>
                                                        </button>
                                                    ) :
                                                        (
                                                            loader ? <ButtonLoader /> : <button
                                                                type="submit"
                                                                className={`${formBtn1} relative px-4 py-2 text-white font-bold rounded-lg flex items-center justify-center`}
                                                            >
                                                                <span className="opacity-100">
                                                                    Submit
                                                                </span>
                                                            </button>
                                                        )
                                                }
                                                <button
                                                    type="button"
                                                    className="w-auto lg:px-8 px-4 transition-colors font-tb tracking-wide duration-200 py-2.5 overflow-hidden text-base font-semibold text-center text-base-color border-2 border-base-color rounded-lg hover:text-white hover:bg-[var(--bg-base-color)] capitalize"                                                    onClick={toggle}
                                                >
                                                    Close
                                                </button>
                                            </footer>
                                        </form>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}
